<template>
  <label class="checkbox">
    <input type="checkbox" :value="value" :checked="value" @change="updateCheckbox"/>
    <span class="checkbox__box">
      <svg width="1em" height="1em" class="icon icon-check">
        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
      </svg>
    </span>
    <span class="checkbox__name">{{label}}</span>
  </label>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    value: Boolean,
    label: {
      type: String,
      required: true,
    }
  },
  methods: {
    updateCheckbox(event) {
      const isChecked = event.target.checked;
      this.$emit('input', isChecked)
    }
  },
}
</script>

<style lang="scss" scoped>
.checkbox {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  width: fit-content;

  &__box {
    width: 1.6rem;
    height: 1.6rem;
    position: relative;
    border-radius: 2px;
    background: #fff;
    border: 1px solid #959595;
    flex-shrink: 0;
    cursor: pointer;
    margin-right: 5px;

    & .icon-check {
      font-size: 8px;
      color: #606060;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s ease, visibility 0.3s ease;
    }
  }

  & input:checked + &__box .icon-check {
    opacity: 1;
    visibility: visible;
  }

  &__name {
    font-weight: 500;
    font-size: 1.2rem;
    color: #1b1b1b;
    line-height: 1.5em;
  }
}
</style>